export const DuplicatesAction = {
  Ignore: "ignore",
  Override: "override",
};
